/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["cc-section[_ngcontent-%COMP%]{position:absolute;top:60px;left:260px;width:calc(100% - 260px);display:flex;flex-direction:column;justify-content:center}"];
export { styles as styles };
